jQuery(document).ready(function ($) {

    // recolte des galeries : chaque .bloc_galerie .photos = un groupe independant
    var groups = [];

    $(".bloc_galerie .photos").each(function () {

        var links = $(this).find("a[href]");
        if (!links.length) return;

        var items = links.map(function () {
            var $a = $(this);
            return {
                src: $a.attr("href"),
                caption: ($a.attr("data-caption") || $a.find("em").text() || "").trim()
            };
        }).get();

        var groupIndex = groups.length;
        groups.push(items);

        links.each(function (i) {
            $(this).on("click", function (e) {
                e.preventDefault();
                open(groupIndex, i);
            });
        });
    });

    if (!groups.length) return;

    // overlay unique injecte dans le body
    var $lb = $(
        '<div class="lightbox" aria-hidden="true">' +
            '<button class="lightbox__close" type="button" aria-label="Fermer"><i class="fa-light fa-xmark"></i></button>' +
            '<button class="lightbox__nav lightbox__prev" type="button" aria-label="Precedent"><i class="fa-light fa-angle-left"></i></button>' +
            '<button class="lightbox__nav lightbox__next" type="button" aria-label="Suivant"><i class="fa-light fa-angle-right"></i></button>' +
            '<div class="lightbox__stage">' +
                '<figure class="lightbox__figure">' +
                    '<img class="lightbox__img" alt="">' +
                '</figure>' +
            '</div>' +
            '<div class="lightbox__bar">' +
                '<span class="lightbox__caption"></span>' +
                '<span class="lightbox__counter"></span>' +
            '</div>' +
        '</div>'
    ).appendTo("body");

    var lb = $lb[0];
    var $img = $lb.find(".lightbox__img");
    var $figure = $lb.find(".lightbox__figure");
    var $caption = $lb.find(".lightbox__caption");
    var $counter = $lb.find(".lightbox__counter");
    var $stage = $lb.find(".lightbox__stage");

    var current = [];   // groupe affiche
    var index = 0;
    var busy = false;   // verrou pendant la transition slide

    function render() {
        var item = current[index];
        $img.attr("src", item.src);
        $caption.text(item.caption);
        $counter.text((index + 1) + " / " + current.length);
    }

    function open(groupIndex, i) {
        current = groups[groupIndex];
        index = i;
        render();

        $lb.attr("aria-hidden", "false");
        document.addEventListener("keydown", onKey);

        gsap.killTweensOf([lb, $figure[0]]);
        gsap.set(lb, { autoAlpha: 0 });
        gsap.set($figure[0], { x: 0, scale: 0.92, autoAlpha: 0 });
        gsap.to(lb, { autoAlpha: 1, duration: 0.3, ease: "power1.out" });
        gsap.to($figure[0], { scale: 1, autoAlpha: 1, duration: 0.4, ease: "power2.out" });
    }

    function close() {
        document.removeEventListener("keydown", onKey);
        busy = false;
        gsap.killTweensOf([lb, $figure[0]]);
        gsap.to(lb, {
            autoAlpha: 0, duration: 0.25, ease: "power1.in",
            onComplete: function () { $lb.attr("aria-hidden", "true"); }
        });
    }

    // dir : 1 = suivant, -1 = precedent (slide horizontal directionnel)
    function go(dir) {
        if (busy || current.length < 2) return;
        busy = true;

        var next = (index + dir + current.length) % current.length;
        var w = $stage.width() || window.innerWidth;   // traverse pleine largeur
        var outX = dir > 0 ? -w : w;
        var inX = dir > 0 ? w : -w;

        // precharge la prochaine image pour eviter le flash
        var pre = new Image();
        pre.onload = pre.onerror = function () {
            gsap.to($figure[0], {
                x: outX, autoAlpha: 0, duration: 0.28, ease: "power2.in",
                onComplete: function () {
                    index = next;
                    render();
                    gsap.set($figure[0], { x: inX });
                    gsap.to($figure[0], {
                        x: 0, autoAlpha: 1, duration: 0.35, ease: "power2.out",
                        onComplete: function () { busy = false; }
                    });
                }
            });
        };
        pre.src = current[next].src;
    }

    function onKey(e) {
        if (e.key === "Escape") close();
        else if (e.key === "ArrowRight") go(1);
        else if (e.key === "ArrowLeft") go(-1);
    }

    $lb.find(".lightbox__next").on("click", function () { go(1); });
    $lb.find(".lightbox__prev").on("click", function () { go(-1); });
    $lb.find(".lightbox__close").on("click", close);

    // clic sur le fond (hors image et boutons) = fermeture
    $lb.on("click", function (e) {
        if (e.target === lb || e.target === $stage[0]) close();
    });

});
